export const SET_ATTACHMENTS = 'SET_ATTACHMENTS';
export const DEL_ATTACHMENT = 'DEL_ATTACHMENT';

export function setAttachments(data) {
  return {
    type: SET_ATTACHMENTS,
    payload: data,
  }
}

export function actionDeleteAttachment(data) {
  return {
    type: DEL_ATTACHMENT,
    payload: data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/attachments/index.js